import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Divider} from 'shells/layout/divider';
import {LinkWithCopyButton} from 'shells/link/link-with-copy-button';

import type {MeetingStubFragment} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {getMeetingTypeAsString} from '../helpers';

import {getHostSection} from './helpers';

import styles from './meeting-review-card-bottom.module.css';

type Props = {
    meeting: MeetingStubFragment;
};

export function MeetingReviewCardBottom(props: Props) {
    const {user} = useGetSessionUser();
    const meetingType = getMeetingTypeAsString(props.meeting);
    const hostSection = getHostSection(props.meeting, user);

    return (
        <div className={styles.container}>
            {hostSection}
            <div className='flex align-center'>
                {meetingType !== '' && (
                    <>
                        <div>{meetingType}</div>
                        <Divider variant='dot' spacing={4} color={colors.greyLt} />
                    </>
                )}
                <div>{props.meeting.activityType.name}</div>
                <Divider variant='dot' spacing={4} color={colors.greyLt} />
                <div>{props.meeting.durationMinutes} minutes</div>
            </div>
            <div>
                <LinkWithCopyButton link={props.meeting.publicMeetingLink} size='small' />
            </div>
        </div>
    );
}
